import "./index.css";
import React, { useState } from "react";
import { isNullOrUndefinedOrEmpty } from "../../common/utils";

export const CollapsibleList = ({ children, labelName, className, maxLines = 2 }) => {
  const [visible, setVisible] = useState(false);
  const getShowMoreTextVisibility = (value) => (value ? "none" : "block");
  const getChildVisibility = (value) => (value ? "block" : "none");
  let modifiedChildren = [];
  if (isNullOrUndefinedOrEmpty(children)) {
    modifiedChildren.push(<span> None </span>);
  } else {
    let remainingChildrenInvisible = false;
    React.Children.map(children, (child, index) => {
      if (maxLines === index) {
        const showMoreText = (
          <span
            key="show-more"
            className={"linkSpan"}
            style={{
              display: getShowMoreTextVisibility(visible),
              textAlign: "left",
              cursor: "pointer",
            }}
            onClick={() => {
              setVisible(true);
            }}
          >
            {" "}
            Show more &nbsp;...
          </span>
        );
        modifiedChildren.push(showMoreText);
        remainingChildrenInvisible = true;
      }
      if (remainingChildrenInvisible) {
        const clonedElement = React.cloneElement(child, {
          style: { display: getChildVisibility(visible), paddingBottom:"8px" },
        });
        modifiedChildren.push(clonedElement);
      } else {
        modifiedChildren.push(child);
      }
    });

    const showLessText = (
      <span
        key="show-less"
        className={"linkSpan"}
        style={{ display: getChildVisibility(visible), textAlign: "left", cursor: "pointer" }}
        onClick={() => {
          setVisible(false);
        }}
      >
        Show less
      </span>
    );
    modifiedChildren.push(showLessText);
  }

  return (
    <div className={`listWithLabel`}>
      {labelName && <div className={"listLabel"}>{labelName}:</div>}
      <div
        key="list-content"
        className={`listContent ${className}`}
      >
        {modifiedChildren}
      </div>
    </div>
  );
};
